import React, { FunctionComponent, useCallback, useMemo } from 'react'
import { GenericInput } from '@dxp-module/common'
import { MyAccountWidgetProps } from '../../../model/MyAccountWidgetProps'
import myAccountGenericInputStyles from '../myAccountGenericInput.styles'

const InputFieldWithHyphen: FunctionComponent<MyAccountWidgetProps> = props => {
  const { label, required, id, onChange, value, rawErrors, disabled, schema } =
    props
  const { readOnly, disabled: schemaDisabled } = schema
  const isDisabled = disabled || schemaDisabled || readOnly

  const currentError = useMemo(() => {
    if (rawErrors) {
      return rawErrors?.length > 0 ? rawErrors[0] : undefined
    }
  }, [rawErrors])
  const styles = myAccountGenericInputStyles()

  const formatString: (value: string) => string = value => {
    if (!value?.length) {
      return ''
    }

    const val = value.replace(/-/g, '')

    return (
      val.substring(0, val.length - 1) + '-' + val.substring(val.length - 1)
    )
  }

  const handleChange = useCallback(
    (e: React.ChangeEvent<{ value: string }>) => {
      const formattedString = formatString(e.target.value as string)

      onChange(formattedString)
    },
    [value]
  )

  const inputValue = value?.includes('-') ? value : formatString(value)

  return (
    <GenericInput
      label={label}
      required={required}
      id={id}
      onChange={handleChange}
      value={inputValue}
      currentError={
        currentError
          ? {
              props: {
                id: currentError,
                defaultMessage: currentError,
              },
            }
          : undefined
      }
      classes={styles}
      disabled={isDisabled}
    />
  )
}

export default InputFieldWithHyphen
